import(/* webpackMode: "eager" */ "/frontend/src/app/not-found.tsx");
